import { render } from "./Home.vue?vue&type=template&id=0a84d000"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=0a84d000&lang=scss"
script.render = render

export default script